// frontend-web/src/pages/Admin/Subjects.js

import React, { useState, useEffect } from 'react';
import api from '../../api';

const Subjects = () => {
  const [subjects, setSubjects] = useState([]);
  const [classes, setClasses] = useState([]);
  const [name, setName] = useState('');
  const [classId, setClassId] = useState('');

  useEffect(() => {
    fetchClasses();
    fetchSubjects();
  }, []);

  const fetchClasses = () => {
    api.get('/admin/classes').then(res => setClasses(res.data));
  };

  const fetchSubjects = () => {
    api.get('/admin/subjects').then(res => setSubjects(res.data));
  };

  const handleAdd = () => {
    if (!name || !classId) return alert('Fill all fields');
    api.post('/admin/subjects', { name, class_id: parseInt(classId) })
      .then(() => {
        setName(''); setClassId('');
        fetchSubjects();
      })
      .catch(err => alert(err.response?.data?.msg || 'Error'));
  };

  return (
    <div style={{ padding: '20px' }}>
      <h2>Manage Subjects</h2>

      <div style={{ marginBottom: '20px' }}>
        <h3>Add Subject</h3>
        <select value={classId} onChange={e => setClassId(e.target.value)}>
          <option value="">Select Class</option>
          {classes.map(cls => (
            <option key={cls.id} value={cls.id}>{cls.name}</option>
          ))}
        </select>
        <input
          placeholder="Subject Name"
          value={name}
          onChange={e => setName(e.target.value)}
          style={{ margin: '0 10px', padding: '8px' }}
        />
        <button onClick={handleAdd}>Add</button>
      </div>

      <h3>Subjects List</h3>
      <table border="1" style={{ width: '100%', textAlign: 'left' }}>
        <thead>
          <tr>
            <th>ID</th>
            <th>Name</th>
            <th>Class</th>
          </tr>
        </thead>
        <tbody>
          {subjects.map(sub => (
            <tr key={sub.id}>
              <td>{sub.id}</td>
              <td>{sub.name}</td>
              <td>{sub.class_name || sub.class_id}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default Subjects;